<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from '@/components/widgets/raw-data.vue'
import PostButton from '@/components/widgets/finance-post-btn.vue'

export default {
    name: "BursList",
    components: {
        LoadingTemplate,
        RawData,
        PostButton
    },
    props: {
        type: {
            type: String,
            default: 'pending'
        },
        loading: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        filtered(){
            let data = this.list;
            var total = this.currentPage * this.perPage;
            if(this.filter){
                data = data.filter(item => {
                    return item.filterKey.toLowerCase().includes(this.filter.toLowerCase())
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            return this.filtered.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage).length;
        }
    },
    data() {
        return {
            tabModel: 0,
            form: {
                postDate: new Date()
            },
            filter: null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
        }
    },
    methods: {
        formatText(text) {
            return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },
        postNow(form, data) {
            this.$emit('post', {form, data});
        },
    },
}
</script>
<template>
  <section class="border-s">
    <div class="card">
        <div class="card-body bg-soft" :class="{'bg-success': type === 'posted', 'bg-warning': type === 'pending', 'bg-primary': type === 'available'}">
            <div
                class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                "
            >
                <div>
                    <h4 class="card-title mb-0">
                        {{type.charAt(0).toUpperCase() + type.slice(1)}} Budget Utilization Request
                    </h4>
                    <p class="card-title-desc mb-0">
                        List of {{type}} Budget Utilization Request
                    </p>
                </div>
                <div v-if="list.length > 0">
                    <div class="d-flex">
                        <input
                            autocomplete="off"
                            type="text"
                            v-model="filter"
                            placeholder="Search BURS/ORS..."
                            class="form-control"
                        />
                        <b-form-select
                            class="form-select ms-1 w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="text-center my-5 py-5">
                <LoadingTemplate class="my-5"/>
            </div>
            <div v-if="!loading && list.length == 0" class="text-center">
                <h5>No data available</h5>
            </div>
            <div v-if="!loading && list.length && !filtered.length" class="text-center">
                <h5>Search not found</h5>
            </div>
            <template v-if="list.length">
                <div
                    role="tablist"
                    v-for="(y, index) in filtered"
                    :key="y.id"
                >
                    <b-card
                        no-body
                        class="mb-1 shadow-none"
                        :style="{'z-index': `${filtered.length - index}`}"
                    >
                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                        <b-card-header
                            header-tag="header"
                            role="tab"
                            header-class="cursor-pointer"
                            @click="y.viewDetails = !y.viewDetails"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                            >
                                <h6 class="m-0">
                                    <a class="text-dark" href="javascript: void(0);">
                                        &nbsp;
                                        <span class="text-warning">[{{ y.serialNumber}}]</span>
                                        <span>[{{y.rfpNumber}}]</span>
                                        :&nbsp;
                                        {{ y.particulars }} <span class="text-yellow">({{ formatCurrency(y.total) }})</span>
                                    </a>
                                </h6>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="d-flex align-items-center text-truncate">
                                            <small v-if="!y.viewDetails">Click here to expand</small>
                                            <i 
                                                class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                :class="{'rotate-90': y.viewDetails }"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse
                            :visible="y.viewDetails"
                            :accordion="`accordion-${y.id}`"
                            role="tabpanel"
                        >
                            <div class="card-body border">
                                <div class="row">
                                    <div class="col-md-7 border-end">
                                        <table class="w-100">
                                            <tr>
                                                <td class="px-2">Particulars:</td>
                                                <td class="px-2"><strong>{{y.particulars}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Serial Number:</td>
                                                <td class="px-2"><strong>{{y.serialNumber}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Total Amount:</td>
                                                <td class="px-2"><strong>{{formatCurrency(y.total)}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Utilization Request Date:</td>
                                                <td class="px-2"><strong>{{ y.bursDate ? formatDate(new Date(y.bursDate)) : '-' }}</strong></td>
                                            </tr>
                                            <tr class="border-bottom">
                                                <td class="px-2">Due And Demandable:</td>
                                                <td class="px-2"><strong>{{y.isDueAndDemandable ? 'Yes' : 'No'}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 pt-2">Request For Payment Number:</td>
                                                <td class="px-2 pt-2"><strong>{{y.rfpNumber}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Payee:</td>
                                                <td class="px-2"><strong>{{y.payee || '-'}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Payee Address:</td>
                                                <td class="px-2"><strong>{{y.payeeAddress || '-'}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Delivery Unit:</td>
                                                <td class="px-2"><strong>{{y.deliveryUnit || '-'}}</strong></td>
                                            </tr>
                                            <tr>
                                                <td class="px-2">Created By:</td>
                                                <td class="px-2"><strong>{{y.createdByUser || '-'}}</strong></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md-5">
                                        <h5>Allotment Charging</h5>
                                        <div class="bg-info bg-soft py-2 px-3 rounded" v-if="y.accounts && y.accounts.length > 0">
                                            <div v-for="(account, index) in y.accounts" :key="index">
                                                <p class="d-block mb-0">{{account.uacsCode}}</p>
                                                <h4 class="mb-0">{{ account.accountName }}</h4>
                                                <div class="text-right mt-3">
                                                    <h3 class="mb-0 text-warning">{{ formatCurrency(account.amount) }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end gap-1 border-top pt-3 mt-2">
                                    <div class="d-flex gap-1">
                                        <button v-if="type === 'pending'" type="buttton" class="btn btn-outline-info btn-rounded" @click="$emit('update', y)"><i class="bx bx-edit"></i> Update</button>
                                        <button v-if="type === 'pending'" type="buttton" class="btn btn-outline-danger btn-rounded" @click="$emit('remove', y.id)"><i class="bx bx-trash"></i> Remove</button>
                                        <button type="buttton" class="btn btn-outline-purple btn-rounded" @click="$emit('printBurs', y.id)"><i class="bx bx-printer"></i> Print BURS</button>
                                        <button type="buttton" class="btn btn-outline-warning btn-rounded" @click="$emit('attachment', {att: ['po', 'rfp', 'burs'], id: y.id})"><i class="bx bx-paperclip rotate rotate-45"></i> Attachments</button>
                                        <button 
                                            v-if="type === 'available'"
                                            type="buttton" 
                                            class="btn btn-outline-success btn-rounded" 
                                            @click="$emit('createDisbursement', y)"
                                        >
                                            <i class="bx bx-pencil"></i> Create Disbursement
                                        </button>
                                        <PostButton 
                                            :data="y"
                                            @postNow="postNow($event, y)"
                                            v-if="type == 'pending'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul
                                class="
                                    pagination pagination-rounded
                                    mb-0
                                "
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
  </section>
</template>
<style lang="scss">
.pur-list{
    padding: 10px 30px;
    border-radius: 25px;
    cursor: pointer;
    &.active{
        background-color: var(--bs-purple);
        color: white;
    }
}
.dot-success{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--bs-success);
    margin-right: 5px;
}
.border-top{
    border-top: 1px solid var(--bs-border-color);
}
.parent-burs:last-child .border-abs::before{
    height: 60% !important;
}
.border-abs{
    &::before{
        content: "";
        position: absolute;
        height: 100%;
        width: 2px;
        left: calc(50% - 25px);
        top: -25px;
        border: 1px dashed var(--bs-gray-400);
    }
    &::after{
        content: "";
        position: absolute;
        height: 2px;
        width: 100%;
        left: calc(50% - 25px);
        top: calc(60% - 25px);
        display: flex;
        align-items: center;
        border: 1px dashed var(--bs-gray-400);
    }
}
</style>